import { Alert } from '@vnetwork/ui/feedback';
import type { DomainDraft } from './wizard-types';
import styles from './DomainSetupWizard.module.css';

/**
 * Step 2 — DNS guidance. The exact edge target is issued per-domain after
 * creation (shown on the domain Overview), so this step explains the record to
 * add and is skippable until DNS is configured.
 */
export function StepDns({ draft }: { draft: DomainDraft }) {
  const name = draft.domain.trim() || 'www.example.com';
  return (
    <>
      <div className={styles.recordCard}>
        <div className={styles.recordRow}>
          <span className={styles.recordLabel}>Type</span>
          <strong>CNAME</strong>
        </div>
        <div className={styles.recordRow}>
          <span className={styles.recordLabel}>Name</span>
          <code>{name}</code>
        </div>
        <div className={styles.recordRow}>
          <span className={styles.recordLabel}>Target</span>
          <span>Issued on the domain Overview after setup</span>
        </div>
      </div>

      <Alert tone="info">
        DNS changes can take up to a few hours to propagate. You can finish setup now and add the
        record later — the domain stays in a pending state until DNS resolves to the edge.
      </Alert>
    </>
  );
}
